import React from "react";

export default function PageHero({ overline, title, subtitle, image }) {
  return (
    <section className="relative overflow-hidden border-b border-[#203E70] bg-[#06122E]">
      {image && <img src={image} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-35 pointer-events-none select-none" />}
      <div className="absolute inset-0 grid-texture bg-[#06122E]/50 pointer-events-none" />
      <div className="cb-container py-16 sm:py-24 relative z-10">
        {overline && <p className="overline mb-3" style={{ color: "#D8AE4E" }}>{overline}</p>}
        <h1 className="font-serif font-bold text-4xl sm:text-5xl text-white tracking-tight max-w-3xl">{title}</h1>
        {subtitle && <p className="text-slate-300 text-lg mt-4 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
